module.exports = __webpack_public_path__ + "img/ZB53详情页_10.6ca58b45.jpg";